import React from "react";

export default function Finance(props) {
  return (
    <>
      <div>
        {" "}
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div class="breadcrumb-section mb-120">
              <div class="container mb-70">
                <div class="row">
                  <div class="col-xl-8 col-lg-10">
                    <div class="breadcrumb-content">
                      <ul class="breadcrumb-list">
                        <li>
                          <a href="service-details.html#">Home</a>
                        </li>
                        <li>
                          <svg
                            width="24"
                            height="6"
                            viewBox="0 0 24 6"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05L-3.26633e-05 2.88672ZM23.7735 2.88672L20.8867 -3.26633e-05L18 2.88672L20.8867 5.77347L23.7735 2.88672ZM2.88672 2.88672V3.38672H20.8867V2.88672V2.38672H2.88672V2.88672Z" />
                          </svg>
                          Financials
                        </li>
                      </ul>
                      <h1>Financials Software</h1>
                      <div class="para">
                        <div class="icon">
                          <svg
                            width="6"
                            height="49"
                            viewBox="0 0 6 49"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 48.7735L5.77347 45.8867L2.88672 43L-3.26633e-05 45.8867L2.88672 48.7735ZM2.88672 2.88672H2.38672L2.38672 45.8867H2.88672H3.38672L3.38672 2.88672H2.88672Z" />
                          </svg>
                        </div>
                        <p>
                          {" "}
                         With access to the complete financial performance of their organisation, all leaders across the operations gain the insights required for rapid strategic decisions.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

           <div class="home4-portfolio-section mb-120">
                <div class="container">
                    <div class="row gy-3 mb-60 justify-content-between">
                        <div class="col-lg-7">
                            <div class="section-title home4-section-title three">
                                <span>Construction</span>
                                <div class="left-content">
                                    
                                   
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="right-content">
                                <a href="portfolio-classic.html" class="view-more-btn style-2">
                                    <svg class="border" width="88" height="1" viewBox="0 0 88 1"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="88" height="1" />
                                    </svg>
                                    View All</a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 mb-70">
                            <div class="porfolio-card-wrapper">
                                <div class="portfolioCard">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="portfolio-content">
                                                <div class="portfolio-content-top">
                                                    <h3><a href="portfolio-details.html">Financials Applications Overview</a></h3>
                                                    <p>With Insight Wide Financials gain access to the complete position of your business at any time. Read how core applications, General Ledger, Fixed Assets, Accounts Receivable, Accounts Payable, Resource Management, Payroll and Employee Portal, integrate all financial activities on a single system, delivering the insights necessary to monitor and grow profitability.</p>
                                                   
                                                </div>
                                                <div class="portfolio-content-btm">
                                                    <a href="portfolio-details.html" class="view-details-btn">Contact Us
                                                        <svg class="arrow" width="20" height="20" viewBox="0 0 20 20"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g>
                                                                <path
                                                                    d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z">
                                                                </path>
                                                            </g>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="portfolio-img">
                                                <img src="assets/finance.png" alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              
                               
                               
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-lg-8">
                            <div class="contact-area">
                                <h4>Don’t Hesitate to
                                    Collaborate with Us</h4>
                                <a class='primary-btn1' href="contact.html">
                                    <span>
                                        Contact us
                                        <svg width="20" height="20" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path
                                                    d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                            </g>
                                        </svg>
                                    </span>
                                    <span>
                                        Contact us
                                        <svg width="20" height="20" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path
                                                    d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                            </g>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="service-details-page mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="service-details-content-wrap">
                      <div class="row mb-70">
                        <div class="col-lg-12">
                          <div class="service-details-title mb-20">
                            <h2>Key Features:</h2>
                          </div>
                          <div class="key-features-area">
                            <ul class="key-features-list">
                              <li>Budgeting</li>
                              <li class="two">Forecasting</li>
                              <li class="three">Reporting</li>
                              <li class="two">Compliance</li>
                              <li class="four">Auditing </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-80">
                        <div class="col-lg-12">
                          <div class="service-details-title mb-40">
                            <h2>Why Choose Us:</h2>
                          </div>
                          <div class="why-choose-area-wrap">
                            <div class="row g-0">
                              <div class="col-lg-6">
                                <div class="why-choose-area">
                                  <ul class="why-choose-list">
                                    <li>
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>Real-Time Visibility:–</span>{" "}
                                        Stop waiting for month-end reports. Our platform gives you an instant, bird’s-eye view of your cash flow, expenses, and profitability so you can make data-backed decisions on the fly.
                                        </p>
                                      </div>
                                    </li>
                                    <li>
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>
                                          Bulletproof Compliance–
                                          </span>{" "}
                                     Finance is risky, but we make it safe. We build automated audit trails and tax-ready reporting into your system, ensuring you stay compliant with local regulations without the manual headache.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <div class="why-choose-area">
                                  <ul class="why-choose-list">
                                    <li class="justify-content-lg-end">
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>
                                           Smart Forecasting –
                                          </span>{" "}
                                         Don’t just track the past—predict the future. Our advanced analytics use your historical data to project future trends, helping you stay ahead of market shifts and manage your liquidity like a pro.
                                        </p>
                                      </div>
                                    </li>
                                    <li class="justify-content-lg-end">
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>
                                         Precision Automation–
                                          </span>{" "}
                                        Eliminate human error where it matters most. From automated invoicing to seamless payroll integration, we replace messy spreadsheets with a high-performance engine that just works.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
